import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type CancelDeletionRequest = {
    token: string
}

type CancelDeletionSuccessResponse = {
    status: number
};

type CancelDeletionErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type CancelDeletionResponse = CancelDeletionSuccessResponse | CancelDeletionErrorResponse;


export function cancelDeletion(token: string): Promise<CancelDeletionResponse> {
    const hubApi = getHubApi();
    return hubApi.cancelRemoveAccount(window.app.deviceIdentifier, { token });
}
